{{ runChangeDetection }}
<!-- Chat: Search -->
<!-- Chat: Pinned -->
<div *ngIf="allService.arPinnedMessages?.length" class="border-bottom px-md-4 px-lg-8 d-xl-none" id="chat-pinned">
  <div class="container-xxl py-4 py-lg-6">
    <app-message-pinned [Service]="Service" [mode]="'full'"></app-message-pinned>
  </div>
</div>
<!-- Chat: Pinned -->
<div class="collapse border-bottom px-lg-8 px-md-4 bg-white" [class.show]="searchShow">
  <form [formGroup]="FormSearch" (submit)="onSearch()" class="container-xxl py-4 py-lg-6">
    <div class="input-group">
      <input
        #searchInput
        type="text"
        formControlName="q"
        class="form-control"
        placeholder="Поиск по истории сообщений"
      />
      <div class="input-group-append">
        <button class="btn btn-lg btn-ico btn-secondary btn-minimal" type="submit">
          <i-feather name="search" class="icon-md"></i-feather>
        </button>
        <button (click)="closeSearch()" class="btn btn-lg btn-ico btn-secondary btn-minimal" type="button">
          <i-feather name="x" class="icon-md"></i-feather>
        </button>
      </div>
    </div>
  </form>
  <!--<form nz-form [nzLayout]="'inline'" [formGroup]="FormSearch" (ngSubmit)="onSearch()">
    <nz-form-item>
      <nz-form-control nzErrorTip="Please input">
        <nz-input-group nzPrefixIcon="lock">
          <input #searchInput type="text" formControlName="q" nz-input type="password" placeholder="Поиск по истории сообщений" />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzSize="large" nzType="primary" type="submit" nzLoading>
          <i-feather name="search" class="icon-md"></i-feather>
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button (click)="closeSearch()" nz-button nzSize="large" nzType="primary" type="submit">
          <i-feather name="x" class="icon-md"></i-feather>
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>-->
</div>
<!-- Chat: Search -->
<ng-template [ngIf]="Service.loadHistoryError && Service.arHistory?.length === 0" [ngIfElse]="elseBlock">
  <app-error-show
    (onReload)="reload()"
    [Service]="Service"
    [error]="Service.loadHistoryError"
    [reload]="!isNoPermissionPersonalError()"
    [showReport]="!isNoPermissionPersonalError()"
    class="h-100"
  >
    <div *ngIf="isNoPermissionPersonalError()">
      <ng-template [ngTemplateOutlet]="demoMessageRef"></ng-template>
    </div>
    <div
      *ngIf="Service.openChatId === senderService.helpChatId || Service.openChatId === senderService.helpChatUserName"
      class="text-center mb-4">
      <button (click)="senderService.openHelpChatInTelegram()" nz-button nzType="primary" nzDanger nzShape="round">
        <i-feather name="life-buoy" class="mr-2"></i-feather>
        Открыть в Telegram
      </button>
    </div>
  </app-error-show>

</ng-template>
<ng-template #elseBlock>
  <div *ngIf="(isLoaded$ | async) === false && Service.arHistory?.length === 0"
       class="chat chat-load--wrap flex-column justify-content-center text-center">
    <div class="container-xxl">
      <div class="mt-4 mb-3">
        <div class="loader-line"></div>
      </div>
    </div>
  </div>
  <ng-template
    [ngIf]="
      isLoadSearch ||
        ((loadHistoryCompleted$ | async) === false && (isLoadHistoryTop$ | async) !== 'timeout' && isLoadHistoryTop$ | async)"
    [ngIfElse]="dateFixed"
  >
    <div class="load-messages showEffect">
      <div class="load-messages-wrap">
        <div class="dot-carousel d-flex justify-content-between"><i></i><i></i><i></i></div>
      </div>
    </div>
  </ng-template>
  <ng-template #dateFixed>
    <div *ngIf="Service.messageLastDate" id="chat-date" class="position-relative">
      <app-messages-last-date
        [Service]="Service"
        class="w-100 d-block position-absolute text-center mt-3"
      ></app-messages-last-date>
    </div>
  </ng-template>
  <div
    [class.open-dropdown]="(interfaceService.openDropdown$ | async)?.component === 'messages-scroll'"
    #viewportRef
    class="viewport chat-content-bg messages-container"
    [class.scroll-stop]="(isLoadHistoryTop$ | async) === 'timeout'"
    [class.opacity-0]="historyHidden$ | async"
  >
    <div (deferVizible)="loadHistoryTop($event)" class="loadHistoryTop"></div>
    <div [attr.data-size]="getContainerSize" (mouseup)="selectMessages()" #messagesContainer
         class="container-xxl my-6 py-lg-6 px-2 px-lg-6 ">

      <ng-template [ngIf]="(loadHistoryCompleted$ | async) && Service.type !== 'sender'">
        <app-messages-profile
          class="scroll-item"
          *ngIf="(interfaceService.isShowTextarea$ | async)"
          [Service]="Service"
          [chat]="Service.openChat"
        ></app-messages-profile>
        <div *ngIf="inlineMode && !(interfaceService.isShowTextarea$ | async)">
          <div class="no-messages-block mb-4">
            <ng-template [ngIf]="Service.arHistory?.length === 0" [ngIfElse]="continueChat">
              <p class="text-center position-relative">По этому лиду еще нет переписки</p>
            </ng-template>
            <ng-template #continueChat>
              <p class="text-center position-relative">У вас уже есть переписка</p>
            </ng-template>

          </div>
          <ng-template [ngTemplateOutlet]="demoMessageRef"></ng-template>
        </div>
      </ng-template>


      <!-- Message -->
      <ng-template
        ngFor
        let-i="index"
        let-c="count"
        let-message
        [ngForOf]="Service.arHistory"
        [ngForTrackBy]="trackByFn"
      >
        <ng-template [ngIf]="message?.show && !message?.replace">
          <div class="scroll-item messages-date text-center mt-2 mb-4" *ngIf="message.show_title">
              <span class="badge badge-lg badge-primary position-relative rounded-lg shadow-sm"
              ><i-feather name="calendar"></i-feather>
                {{ message.date_format }}</span
              >
          </div>
          <!-- (deferLoad)="vizibleMesage($event, message, i)" -->
          <app-message
            [contextMenu]="contextMenu"
            [contextMenuSubject]="message"
            (contextMenuOpen)="contextMenuOpen($event)"
            [ngClass]="{
                'message-prev-user': message.prev_user ,
                'message-space': message.space
              }"
            [isAvatar]="
                message.from_user?.id && Service.openChat?.type !== 'channel'
              "
            (dblclick)="dbClick($event, message)"
            [attr.id]="'message-' + message.id"
            [attr.data-id]="message.id"
            *ngIf="!message?.service; else serviceMessage"
            class="scroll-item message message-base px-3"
            [class.open]="message.id === (interfaceService.openDropdown$ | async)?.id"
            [class.message-right]="message.out"
            [class.read]="message.read"
            [class.mesage-hidden]="message.hidden"
            (onToggleMessage)="onToggleMessage.next($event)"
            (onEditMessage)="onEditMessage.next($event)"
            (onReplyMessage)="onReplyMessage.next($event)"
            [message]="message"
            [Service]="Service"
            [messagesContainer]="messagesContainer"
            [index]="i"
          ></app-message>
          <div
            *ngIf="!message.read && !message.out"
            class="scroll-item read-history"
            (deferVizible)="readMessage($event, 1500, message)"
          ></div>
          <ng-template #serviceMessage>
            <app-message-service
              *ngIf="Service.type !== 'sender'; else senderMessage"
              [index]="i"
              [message]="message"
              class="scroll-item message px-3 px-lg-6"
              [Service]="Service"

            ></app-message-service>
            <ng-template #senderMessage>
              <app-message-sender
                *ngIf="message.chat_id === 'sender'; else senderPartner"
                [contextMenu]="contextMenu"
                [contextMenuSubject]="message"
                (contextMenuOpen)="contextMenuOpen($event)"
                [class.open]="message.id === (interfaceService.openDropdown$ | async)?.id"
                (dblclick)="dbClick($event, message)"
                [attr.data-id]="message.id"
                [message]="message"
                [Service]="Service"
                (onToggleMessage)="onToggleMessage.next($event)"
                (onEditMessage)="onEditMessage.next($event)"
                class="scroll-item message read message-sender px-3 px-lg-6">
              </app-message-sender>
            </ng-template>

            <ng-template #senderPartner>

              <app-message-sender-partner
                [message]="message"
                [Service]="Service"
                class="scroll-item message read message-sender px-3 px-lg-6">

              </app-message-sender-partner>
            </ng-template>
          </ng-template>
        </ng-template>
      </ng-template>

      <div [class.active]="Service.arHistory?.length === 0" class="spaceNotMessages"></div>
      <div
        (click)="readHistory(0, true)"
        *ngIf="(showReadBtn$ | async) && Service.openChat.type !== 'channel'"
        class="readButton text-center mt-3 showEffect"
      >
        <button class="btn btn-outline-dark btn-sm py-2">Прочитать сообщения</button>
      </div>
      <button
        [@inOutAnimation]
        (click)="scrollToEnd(); readHistory(0)"
        *ngIf="(unreadCount$ | async) > 0"
        class="btn btn-ico btn-primary rounded-circle unreadButton"
      >
        <span class="unreadCount">{{ unreadCount$ | async }}</span>
        <i-feather name="chevron-down" class="icon-lg"></i-feather>
      </button>
      <div class="px-3 px-lg-6 ai_chat_mode--{{Service._openChat.ai_chat_mode}}">
        <div
          [class.sender-info--warning]="Service._openChat.ai_chat_mode === 'manager'"
          class="sender--info my-8 d-flex p-0 shadow">
          <div class="sender-info--icon d-flex align-items-center justify-content-center">
            <i-feather [style.line-height.px]="10" name="alert-triangle" class="text-white"></i-feather>
          </div>
          <div class="sender-info--text">
              <p class="">
                <ng-container *ngIf="Service._openChat.ai_chat_mode === 'ai_bot' || !Service._openChat.ai_chat_mode">
                  🤖 ИИ-помощник активен. Переключитесь на ручной режим для личного общения с клиентом.
                </ng-container>

                <ng-container *ngIf="Service._openChat.ai_chat_mode === 'manager'">
                  👤 Ручной режим активен. Включите ИИ-помощника для автоматических ответов.
                </ng-container>
              </p>
            <div class="text-right">
              <nz-radio-group (ngModelChange)="fellowdeskService.setChatMode(Service._openChat.id, $event)" [(ngModel)]="Service._openChat.ai_chat_mode" nzButtonStyle="solid">
                <label nz-radio-button nzValue="manager"><i-feather class="mr-1" name="user"></i-feather>Менеджер</label>
                <label nz-radio-button nzValue="ai_bot"><i-feather class="mr-1" name="cpu"></i-feather>Ai бот</label>
              </nz-radio-group>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="Service.openChatId === 'partner'" class="px-3 px-lg-6">
        <div class="sender--info my-8 d-flex p-0 shadow">
          <div class="sender-info--icon d-flex align-items-center justify-content-center">
            <i-feather [style.line-height.px]="10" name="info" class="text-white"></i-feather>
          </div>
          <div>
            <div class="sender-info--text">
              <i-feather name="chevrons-right"></i-feather>
              Приглашайте ползователей, получайте 15% с суммы пополнений.
              <div></div>
              <i-feather name="chevrons-right"></i-feather>
              Для начала сотрудничества, Вам нужно всего лишь скопировать ссылку ниже и рекомендовать наш сервис по этой
              ссылке. Зарегистрировавшиеся будут видны Вам в этом списке.
            </div>
          </div>

        </div>
      </div>

      <app-demo-message-sender id="sender-demo"
                               *ngIf="Service._openChatId === 'sender' && !senderService.tourComplete && (isLoaded$ | async) && senderService.arHistory?.length === 0"
                               [contextMenu]="contextMenu"
      ></app-demo-message-sender>
      <div *ngIf="Service.openChatId === 'sender'" class="text-center z-index-max position-relative">
        <nz-button-group>
          <button *ngIf="!senderService._senderAddForm" (click)="interfaceService.editor.commands.focus();" nz-button
                  nzType="primary" class="mb-2" nzShape="round">
            <i-feather name="send" class="mr-2"></i-feather>
            Создать рассылку
          </button>
          <button (click)="interfaceService.addAccount(Service)" nz-button
                  [nzType]="Service.arHistory?.length > 0 ? 'default' : 'default'" class="mb-2" nzShape="round">
            <i-feather name="user-plus" class="mr-2"></i-feather>
            Добавить аккаунт
          </button>
          <button (click)="senderService.openHelpChat()" nz-button nzType="primary" nzDanger nzShape="round">
            <i-feather name="life-buoy" class="mr-2"></i-feather>
            Помощь
          </button>

        </nz-button-group>
      </div>


      <div *ngIf="Service.openChatId === 'partner'" class="text-center z-index-max position-relative">
        <nz-input-group *ngIf="(senderService.account$ | async)?.id" class="d-flex mb-5 justify-content-center">
          <input nz-input readonly [value]="senderService.linkPartner" [style.max-width.px]="300">
          <button nz-button nzType="default" (click)="senderService.copyLnkPartner()">
            <i-feather *ngIf="!senderService.isCopyPartnerLink" name="copy"></i-feather>
            <i-feather *ngIf="senderService.isCopyPartnerLink" name="check"></i-feather>
          </button>
        </nz-input-group>
        <nz-button-group>

          <!--<button nz-button
                  nzType="default" class="mb-2" nzShape="round">
            <i-feather name="user-plus" class="mr-2"></i-feather>
            Приграсить
          </button>-->
          <button (click)="senderService.openHelpChat()" nz-button nzType="primary" nzDanger nzShape="round">
            <i-feather name="life-buoy" class="mr-2"></i-feather>
            Помощь
          </button>
        </nz-button-group>
      </div>

      <div *ngIf="Service.openChatId === '@teleseller_chat'" class="text-center z-index-max mt-3 position-relative">
        <button (click)="senderService.openInfoChatInTelegram()" nz-button nzType="primary" nzShape="round">
          <i-feather name="tg" class="mr-2"></i-feather>
          Подписаться в телеграм
        </button>
      </div>


      <ng-template [ngIf]="Service.loadHistoryError && Service.arHistory?.length > 0">
        <app-error-show
          [reload]="false"
          [Service]="Service"
          [error]="Service.loadHistoryError"
          class="h-100"
        >
        </app-error-show>

      </ng-template>
    </div>
  </div>
</ng-template>

<context-menu *ngIf="Service.type !== 'sender'"
              (open)="interfaceService.contextMenuOpenEvent($event, 'messages-scroll')"
              (close)="interfaceService.contextMenuCloseEvent($event)">
  <ng-template [visible]="isTextSelected" (execute)="copySelectedText()" contextMenuItem let-item>
    Копировать выделенный текст&nbsp;<i-feather class="ml-auto float-right" name="copy"></i-feather>
  </ng-template>
  <ng-template [visible]="isText" (execute)="copyText($event.item)" contextMenuItem let-item>
    Копировать весь текст&nbsp;<i-feather class="ml-auto float-right" name="copy"></i-feather>
  </ng-template>
  <ng-template [visible]="isTextModal" (execute)="copyTextModal($event.item)" contextMenuItem let-item>
    Копировать часть текста&nbsp;<i-feather class="ml-auto float-right" name="copy"></i-feather>
  </ng-template>

  <ng-template
    [visible]="Service.openChat?.type !== 'channel'"
    (execute)="replyMessageText($event.item)"
    contextMenuItem
    let-item
  >
    Ответить&nbsp;<i-feather class="ml-auto float-right" name="corner-up-left"></i-feather>
  </ng-template>

  <ng-template [visible]="isPhoto" (execute)="downloadAttachments($event.item, 'photo')" contextMenuItem let-item>
    Сохранить изображение&nbsp;<i-feather class="ml-auto float-right" name="save"></i-feather>
  </ng-template>
  <ng-template [visible]="isVideo" (execute)="downloadAttachments($event.item, 'video')" contextMenuItem let-item>
    Сохранить видео&nbsp;<i-feaZther class="ml-auto float-right" name="save"></i-feaZther>
  </ng-template>
  <ng-template
    [visible]="isVideoNote"
    (execute)="downloadAttachments($event.item, 'video_note')"
    contextMenuItem
    let-item
  >
    Сохранить видеопослание&nbsp;<i-feather class="ml-auto float-right" name="save"></i-feather>
  </ng-template>
  <ng-template [visible]="isDocument" (execute)="downloadAttachments($event.item, 'document')" contextMenuItem let-item>
    Сохранить документ&nbsp;<i-feather class="ml-auto float-right" name="save"></i-feather>
  </ng-template>
  <ng-template [visible]="isAudio" (execute)="downloadAttachments($event.item, 'audio')" contextMenuItem let-item>
    Сохранить аудио&nbsp;<i-feather class="ml-auto float-right" name="save"></i-feather>
  </ng-template>
  <ng-template [visible]="isVoice" (execute)="downloadAttachments($event.item, 'voice')" contextMenuItem let-item>
    Сохранить голосовое&nbsp;<i-feather class="ml-auto float-right" name="save"></i-feather>
  </ng-template>

  <ng-template [visible]="isEdit" (execute)="editMessageText($event.item)" contextMenuItem let-item>
    Изменить&nbsp;<i-feather class="ml-auto float-right" name="edit"></i-feather>
  </ng-template>
  <ng-template
    (execute)="
      modalService.openModal('ModalForwardMessageComponent', {
        Service: Service,
        messages: [$event.item]
      })
    "
    contextMenuItem
    disabled
    let-item
  >
    Переслать сообщение&nbsp;<i-feather class="ml-auto float-right" name="share"></i-feather>
  </ng-template>
  <ng-template contextMenuItem divider="true"></ng-template>
  <ng-template [visible]="isToggle" (execute)="toggleMessage($event.item, true)" contextMenuItem let-item>
    Отменить выбор&nbsp;<i-feather class="ml-auto float-right" name="check"></i-feather>
  </ng-template>
  <ng-template [visible]="isUnToggle" (execute)="toggleMessage($event.item, true)" contextMenuItem let-item>
    Выбрать&nbsp;<i-feather class="ml-auto float-right" name="check"></i-feather>
  </ng-template>
  <ng-template [visible]="isDelete" (execute)="deleteMessage($event.item)" contextMenuItem let-item>
    Удалить сообщение&nbsp;<i-feather class="ml-auto text-danger float-right" name="trash-2"></i-feather>
  </ng-template>
</context-menu>


<context-menu *ngIf="Service.type === 'sender'"
              (open)="interfaceService.contextMenuOpenEvent($event, 'messages-scroll')"
              (close)="interfaceService.contextMenuCloseEvent($event)">
  <ng-template [visible]="senderService.isEdit" (execute)="editMessageText($event.item)" contextMenuItem let-item>
    Изменить&nbsp;<i-feather class="ml-auto float-right" name="edit"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isEdit" (execute)="senderService.deleteSender($event.item)" contextMenuItem let-item>
    Удалить&nbsp;<i-feather class="ml-auto float-right" name="trash"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isPause" (execute)="senderService.pauseSender($event.item)" contextMenuItem
               let-item>
    Продолжить&nbsp;<i-feather class="ml-auto float-right" name="play"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isNotPause" (execute)="senderService.pauseSender($event.item)" contextMenuItem
               let-item>
    Приостановить&nbsp;<i-feather class="ml-auto float-right" name="pause"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isRepry" (execute)="senderService.replySender($event.item)" contextMenuItem
               let-item>
    Повторить&nbsp;<i-feather class="ml-auto float-right" name="edit"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isParsedChat" (execute)="senderService.downloadParsed('xls', $event.item.id)"
               contextMenuItem let-item>
    Скачать контакты XLS&nbsp;<i-feather class="ml-auto float-right" name="table"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isParsedChat" (execute)="senderService.openParsed('xls', $event.item.id)"
               contextMenuItem let-item>
    Смотреть контакты&nbsp;<i-feather class="ml-auto float-right" name="eye"></i-feather>
  </ng-template>
  <ng-template [visible]="senderService.isShowErros" (execute)="senderService.showErrorsModal($event.item)"
               contextMenuItem let-item>
    Показать ошибки&nbsp;<i-feather class="ml-auto float-right" name="alert-octagon"></i-feather>
  </ng-template>
</context-menu>


<ng-template #deleteModalContent>
  <label nz-checkbox [(ngModel)]="Service.isDeleteAllMessage">Удалить для всех</label>
</ng-template>


<ng-template #demoMessageRef>
  <div class="message-demo-wrap" *ngIf="demoMessage as message">
    <div class="message-demo-title">Сообщение в чате:</div>
    <div class="d-flex justify-content-center">
      <app-message
        [isAvatar]="true"
        [attr.id]="'message-' + message.id"
        [attr.data-id]="message.id"
        class="message message-base px-3 px-lg-6 text-left"
        [class.message-right]="message.out"
        [class.read]="message.read"
        [message]="message"
        [Service]="Service"
        [index]="0"
        [messagesContainer]="messagesContainer">
      </app-message>
    </div>
  </div>
</ng-template>
